
import { Options, prop, Vue } from "vue-class-component";
import PickupStatusBadge from "./pickup-status-badge.vue";
import OverlayPanel from "primevue/overlaypanel";

interface MergedShipmentItemProp {
  shipmentId: string;
  koliCount: number;
  weightKg: number;
}

class Props {
  statusCode = prop<string>({ required: true });
  createdAtLabel = prop<string>({ required: true });
  createdByLabel = prop<string>({ required: true });
  courierAvailable = prop<boolean>({ required: true });
  courierName = prop<string>({ required: false, default: "" });
  courierId = prop<number | string>({ required: false, default: "" });
  courierPhoneDisplay = prop<string>({ required: false, default: "" });
  phoneRevealed = prop<boolean>({ required: false, default: false });
  pickupProofUrls = prop<string[]>({ required: false, default: () => [] });
  mergedShipments = prop<MergedShipmentItemProp[]>({
    required: false,
    default: () => []
  });
  canShowCancelButton = prop<boolean>({ required: false, default: false });
  canPrintDhlLabel = prop<boolean>({ required: false, default: false });
  dhlLabelPrintUrl = prop<string>({ required: false, default: "" });

  showClientHeading = prop<boolean>({ required: false, default: false });
  clientRefDisplay = prop<string>({ required: false, default: "" });

  loading = prop<boolean>({ required: false, default: false });
}

@Options({
  name: "PickupDetailSidebar",
  components: {
    PickupStatusBadge,
    OverlayPanel
  },
  emits: [
    "reveal-phone",
    "preview-photo",
    "whatsapp-click",
    "open-cancel-modal",
    "print-label"
  ]
})
export default class PickupDetailSidebar extends Vue.with(Props) {
  showMergePopover = false;

  get displayedProofUrls(): string[] {
    return this.pickupProofUrls.slice(0, 4);
  }

  get waLink(): string {
    const cleanPhone = this.courierPhoneDisplay.replace(/\D/g, "");
    return `https://wa.me/${cleanPhone}`;
  }

  formatMergeItem(item: MergedShipmentItemProp): string {
    return this.$t("pickupV2.detailSidebar.sidebar.merge.listItem", {
      shipmentId: item.shipmentId,
      koliCount: item.koliCount,
      weightKg: item.weightKg,
    }) as string;
  }

  get opKey() {
    return 'pickup-detail-sidebar-merge-popover';
  }

  openOverlayPanel(event: Event) {
    const refs: any = this.$refs;
    refs?.[this.opKey]?.toggle(event);
  }

  closeOverlayPanel(event: Event) {
    const refs: any = this.$refs;
    refs?.[this.opKey]?.hide(event);
  }
  openCancelModal() {
    this.$emit("open-cancel-modal");
  }
  onPrintLabel() {
    this.$emit("print-label");
  }
  photoPreview = false;
  photo = "";
  onPreview(photo: string) {
    this.photo = photo;
    this.photoPreview = true;
  }

  get photoPreviews() {
    return this.pickupProofUrls.map((item: any) => {
      return {
        image: item,
        url: item
      }
    });
  }
}
